import React from 'react';
import { parseLeadsCookie } from '../utilities/parseLeadsCookie';
import getEnvironmentVariables from "../utilities/getEnv";


function WbmLink() {

    let AppEnv = getEnvironmentVariables();
    let url = AppEnv.rootUrl;

    return (
        parseLeadsCookie() != null ?
            <a className="back-click" href={url}> &#60; visit wbmason.com</a> :
            null

    );
}

export default WbmLink;